import clsx from 'clsx';
import type { ReactNode } from 'react';
import { memo, useMemo } from 'react';

import DrawArticle from './components/DrawArticle';
import DrawCommentary from './components/DrawCommentary';
import DrawPots from './components/DrawPots';
import DrawResults from './components/DrawResults';
import DrawTabs from './components/DrawTabs';
import DrawVideo from './components/DrawVideo';
import { useDrawVideoPlayerOptions } from './hooks';
import { DrawTabId } from './store/types';

import { useDrawPolling } from '@apps/draw/hooks';
import { useDrawCentreOptions, useDrawCentreStore } from '@apps/draw-centre/store';
import { useWindowSize } from '@shared/hooks/useWindowSize';
import SlotIncluder from '@shared/SlotIncluder';

import * as styles from './styles.module.scss';

const DrawCentre = ({ placeholder }: { placeholder?: ReactNode }) => {
  const tab = useDrawCentreStore((state) => state.tab);
  const draw = useDrawPolling();
  const {
    options: { videoPromoLibrary },
  } = useDrawCentreOptions();
  const { drawNoVideo, isDrawReplay } = useDrawVideoPlayerOptions();

  const { isMobile, isTablet } = useWindowSize();

  const tabsComponents = useMemo(
    () => ({
      [DrawTabId.RESULTS]: <DrawResults />,
      [DrawTabId.UPDATES]: <DrawCommentary />,
      [DrawTabId.POTS]: <DrawPots />,
      [DrawTabId.PROCEDURE]: <DrawArticle />,
    }),
    [],
  );

  const isSmallScreen = isMobile || isTablet;

  const hasVideo = !drawNoVideo || isDrawReplay;

  if (!draw?.status) return placeholder;

  return (
    <div className={clsx('pk-container pk-theme--light pk-bg--background', styles.drawContainer)}>
      {!isSmallScreen && <SlotIncluder className='pk-col pk-col--span-12 pk-mt--m' path={videoPromoLibrary} />}
      {!!hasVideo && (
        <div
          className={clsx(
            'pk-col',
            !hasVideo ? 'pk-col--span-12' : 'pk-col--span-6',
            isSmallScreen && 'pk-col--span-12',
          )}
        >
          <DrawVideo />
        </div>
      )}
      <div
        className={clsx(
          'draw-right-column pk-col',
          hasVideo ? 'pk-col--span-6' : 'pk-col--span-12',
          isSmallScreen && 'pk-col--span-12',
        )}
      >
        <DrawTabs />
        {tabsComponents[tab]}
      </div>
    </div>
  );
};

export default memo(DrawCentre);
